import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import type { CommonProps } from '../types';

export type SimpleDetailsProps = CommonProps & {
  variant: 'simple';
  SummaryComponent: ReactNode;
};

export function SimpleDetails({
  children,
  detailsProps = {},
  summaryComponentProps = {},
  SummaryComponent,
}: SimpleDetailsProps) {
  const { sx: sxDetailsProps, ...restDetailsProps } = detailsProps;
  const { sx: sxSummaryComponentProps, ...restSummaryComponentProps } = summaryComponentProps;
  return (
    <Box
      sx={{
        position: 'relative',
        '& .expand-icon': {
          transition: 'transform 0.3s',
        },
        '&[open] .expand-icon': {
          transform: 'rotate(-180deg)',
        },
        '&:not([open]) .expand-icon': {
          transform: 'rotate(0deg)',
        },
        ...sxDetailsProps,
      }}
      component="details"
      {...restDetailsProps}
    >
      <Box
        component="summary"
        data-testid="detail-summary"
        sx={{
          listStyle: 'none',
          listStyleType: 'none',
          '::-webkit-details-marker': {
            display: 'none',
          },
          '::marker': {
            display: 'none',
          },
          cursor: 'pointer',
          WebkitTapHighlightColor: 'transparent',
          ...sxSummaryComponentProps,
        }}
        {...restSummaryComponentProps}
      >
        {SummaryComponent}
      </Box>
      {children}
    </Box>
  );
}
